import type { Profile } from './types';

export const profile: Profile = {
  firstName: 'Danilo',
  lastName: 'Targas',
  picture: '/images/profile.jpg',
  i18n: {
    'pt-BR': { profession: 'Desenvolvedor Front-end Sênior' },
    en: { profession: 'Senior Front-end Developer' },
  },
};
